import React from 'react';

import prospectsIcon from '@images/logos/vendor/logoprospectscrmwhite2.png';
import appleIcon from '@images/logos/applebadge.svg';
import googleIcon from '@images/logos/google-play-badge.svg';

const ProspectsMobileWidget = () => (
  <div className="panel-content text-center rounded" style={{ backgroundColor: '#143f62', minHeight: '231px' }}>
    <img alt="prospects-mobile-icon" src={prospectsIcon} className="img-fluid mb-3" style={{ height: '40px' }} />
    <p className="mb-5" style={{ color: 'var(--darkText-2)' }}>
      Prospects Mobile gives you the tools you need to stay connected to critical listing data and client activities while you&apos;re on the go.
    </p>
    <a href="https://apps.apple.com/ca/app/prospects/id422759714" target="_blank" rel="noreferrer" className="mr-2">
      <img src={appleIcon} alt="Apple Store Icon" style={{ height: '45px' }} />
    </a>
    <a href="https://play.google.com/store/apps/details?id=com.prospects_mobile" target="_blank" rel="noreferrer">
      <img src={googleIcon} alt="Google Play Icon" style={{ height: '45px' }} />
    </a>
  </div>
);

export default ProspectsMobileWidget;
